import { Directive, ElementRef, Input } from '@angular/core';

import { PackageStatus } from 'src/app/core/api/models';

@Directive({
    selector: '[packageStatus]',
    standalone: true
})
export class PackageStatusDirective {

    @Input() packageStatus: PackageStatus;

    constructor(private element: ElementRef<HTMLElement>) { }

    ngOnInit(): void {
        this.element.nativeElement.className = this.getCssClassList();
    }

    getCssClassList(): string {

        let classList = "badge tw-font-medium text ";

        switch (this.packageStatus) {
            case PackageStatus.Active:
                classList += 'badge-light-success tw-w-[80px]';
                break;
            case PackageStatus.AddJobFail:
                classList += 'badge-light-rose tw-w-[100px]';
                break;
            case PackageStatus.Canceled:
                classList += 'badge-light-danger tw-w-[80px]';
                break;
            case PackageStatus.Expired:
                classList += ' badge-light-warning tw-w-[80px]';
                break;
            case PackageStatus.ExpiredWithCreditError:
                classList += 'badge-light-info tw-w-[140px]';
                break;
            case PackageStatus.Reserved:
                classList += 'badge-light-blue tw-w-[80px]';
                break;
            case PackageStatus.Finished:
                classList += 'badge-light-dark tw-w-[80px]';
                break;

            default:
                break;
        }
        return classList;
    }

}


